angular.module('CarsSaraBo').controller('AdditionalPriceController', ['$scope', '$rootScope', '$routeParams', '$q', 'PointOfSaleService', 'AdditionalPriceService', '$http', '$location', 'SessionService',
    function ($scope, $rootScope, $routeParams, $q, pointOfSaleService, additionalPriceService, $http, $location, sessionService) {

        $scope.initialize = function () {
            $scope.showProgressBar();
            $scope.validations = {}
            $scope.additionalPrice = {"pointOfSales": []};
            $scope.additionalPrice.included = false;
            $scope.posSelected = {};

            $scope.letInclude = false;
            $scope.isEditing = false;

            $scope.loadData();
            $scope.errorField = {};
            $scope.editableAdditionalPrice = $scope.loggedUserAllowed('PERM_UPSELLING_CREATE');
            $scope.companyOid = $routeParams.companyOid;
            $scope.currencyCode = sessionService.session.currencyCode;
        }

        $scope.loadCompany = function () {
            var fieldsPos = "name,oid,street"
            $scope.pointsOfSale = [];
            pointOfSaleService.resource.query({companyOid: $routeParams.companyOid, fields: fieldsPos}, function (pointsOfSale) {
                $scope.pointsOfSale = pointsOfSale;
                $scope.validations.pointsOfSale = true;
                $scope.hideProgressBar();
            });

            if ($routeParams.oid == "new") return;
            additionalPriceService.getOne({companyOid: $routeParams.companyOid, oid: $routeParams.oid}, function (response) {
                $scope.additionalPrice = response;
                if ($scope.additionalPrice.baseAmount == 0) {
                    $scope.additionalPrice.included = true;
                    $scope.letInclude = true;
                } else {
                    $scope.letInclude = (_.find($scope.ensureAdd, {oid: $scope.additionalPrice.additionalOid}) == null) ? false : true;
                    $scope.additionalPrice.included = false;
                }
                $scope.posSelected[response.posOid] = {"checked": true};
                $scope.isEditing = true;
                $scope.additionalPrice.pointOfSales = [response.posOid];
            });
        }

        $scope.loadData = function () {
            $http.get("../rest/data/additionals").success(function (response) {
                $scope.loadCompany();
                $scope.additionals = response;
                $scope.splitListIfEnsure(response);

            });
        }

        $scope.splitListIfEnsure = function (additionals) {
            $scope.ensureAdd = [];
            $scope.notEnsureAdd = [];
            additionals.forEach(function (e) {
                e.ensureStock == true ? $scope.ensureAdd.push(e) : $scope.notEnsureAdd.push(e);
            });
        }

        $scope.isInEnsureAdd = function (ensureAdd, addOid) {
            for (i in ensureAdd) {
                if (ensureAdd[i].oid == addOid) {
                    return true;
                }
                ;
            }
            return false;
        };

        $scope.updateValidation = function (field) {
            if ($scope.errorField != undefined && $scope.errorField[field]) {
                $scope.errorField[field] = null;
            }
        }

        $scope.save = function () {
            $scope.submitted = true;
            $scope.additionalPrice.oid = null;
            if ($scope.newAdditionalPriceForm.$valid) {
                $scope.includePoinsOfSale($scope.posSelected);
                $q.all([
                    additionalPriceService.post({companyOid: $routeParams.companyOid}, $scope.additionalPrice).$promise,
                ]).then(function (response) {
                    $scope.notifyInfoByCode('additionalPrice.confirmationMessage.SUCCESS_SAVE');
                    $scope.goBack();
                });
            } else {
                $scope.errorField = {};
                for (i in $scope.newAdditionalPriceForm.$error.required) {
                    $scope.errorField[$scope.newAdditionalPriceForm.$error.required[i].$name] = "input-error";
                }
                for (i in $scope.newAdditionalPriceForm.$error.min) {
                    $scope.errorField[$scope.newAdditionalPriceForm.$error.min[i].$name] = "input-error";
                }
                for (i in $scope.newAdditionalPriceForm.$error.pattern) {
                    $scope.errorField[$scope.newAdditionalPriceForm.$error.pattern[i].$name] = "input-error";
                    $rootScope.notifyErrorByCode('warning.invalidNumberFormat');
                }
            }
            $scope.notifyFormErrors($scope.newAdditionalPriceForm.$error);
        }

        $scope.includePoinsOfSale = function (posSelected) {
            for (var i in posSelected) {
                if (posSelected[i].checked == true) {
                    $scope.additionalPrice.pointOfSales.push(i);
                }
            }
        }


        $scope.goBack = function () {
            $location.path("/company/" + $routeParams.companyOid + "/additionalPrice");
        }


        $scope.cancel = function () {
            $scope.showModal("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION", function () {
                $scope.goBack();
            });
        }

        $scope.includePrice = function () {
            if ($scope.additionalPrice.included) {
                $scope.additionalPrice.baseAmount = 0;
            } else {
                $scope.additionalPrice.baseAmount = null;
            }
        }

        $scope.checkAll = function () {
            var select = this.selectedAll;
            angular.forEach($scope.pointsOfSale, function (item) {
                $scope.posSelected[item.oid] = {"checked": select};
            });

        };

        $scope.canInclude = function (canInclude) {
            $scope.letInclude = canInclude;
        }

        $scope.initialize();
    }]);


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/general_conditions_controllers/additional_price_controller.js
// module id = 911
// module chunks = 3